export default "__VITE_ASSET__B2GTjCiB__"